<template>
  <div ref="moderationSummaryWrapper" class="moderation-summary__wrapper">
    <div
      ref="moderationSummary"
      class="moderation-summary"
      :class="{ 'moderation-summary--fixed': isFixed }"
      :style="{ width: width }"
    >
      <Section title="Weryfikacja wydarzenia">
        <section class="moderation-summary__comments">
          <h4 class="moderation-summary__label">Komentarz CO:</h4>
          <div class="comment">
            <!-- <p v-if="adminComment.comment" class="comment__meta">
              <span class="comment__user">
                {{ adminComment.user }}
              </span>
              <span class="comment__date">
                {{ adminComment.date | moment("YYYY-MM-DD") }}
              </span>
            </p> -->
            <p class="comment__message">
              <span v-if="adminComment.comment">
                {{ adminComment.comment | truncate(250) }}
              </span>
              <span v-else>
                Brak
              </span>
              <a
                href="#"
                @click.prevent="
                  showAllComments('Komentarze CO', adminComment, adminComments)
                "
              >
                (więcej)
              </a>
            </p>
          </div>
        </section>

        <section class="moderation-summary__comments">
          <h4 class="moderation-summary__label">
            Komentarz publiczny:
          </h4>
          <div class="comment">
            <!-- <p v-if="publicComment.comment" class="comment__meta">
              <span class="comment__user">
                {{ publicComment.user }}
              </span>
              <span class="comment__date">
                {{ publicComment.date | moment("YYYY-MM-DD") }}
              </span>
            </p> -->
            <p class="comment__message">
              <span v-if="publicComment.comment">
                {{ publicComment.comment | truncate(250) }}
              </span>
              <span v-else>
                Brak
              </span>
              <a
                href="#"
                @click.prevent="
                  showAllComments(
                    'Komentarze publiczne',
                    publicComment,
                    publicComments
                  )
                "
              >
                (więcej)
              </a>
            </p>
          </div>
        </section>
      </Section>
    </div>
  </div>
</template>

<script>
import BaseAdminCertificationSummary from "./BaseAdminCertificationSummary";
import BaseUserCertificationSummaryComment from "./BaseUserCertificationSummaryComment";

import {
  filterComments,
  createCommentModel
} from "./BaseAdminCertificationSummary";

export default {
  name: "BaseUserCertificationSummary",
  components: {
    BaseUserCertificationSummaryComment
  },
  extends: BaseAdminCertificationSummary,
  data() {
    return {
      dialogComponent: "BaseUserCertificationSummaryComment"
    };
  },
  watch: {
    publicComments(allComments) {
      this.publicComment = createCommentModel(
        filterComments(allComments, "previous")
      );
    },
    adminComments(allComments) {
      this.adminComment = createCommentModel(
        filterComments(allComments, "previous")
      );
      if (this.adminComment.comment && this.adminComment.comment.length > 0) {
        this.showAllComments("Komentarz CO", null, [this.adminComment]);
      }
    },
    applicantComments(allComments) {
      this.applicantComment = createCommentModel(
        filterComments(allComments, "previous")
      );
    }
  }
};
</script>
